<template>
    <svg :width="width" :height="height" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <clipPath id="clip-Edit">
                <rect width="24" height="24"></rect>
            </clipPath>
        </defs>
        <g id="Edit" clip-path="url(#clip-Edit)" transform="matrix(1, 0, 0, 1, -5.127907, -4.639535)">
            <rect width="15" height="15" style="fill: #A43A45; fill-opacity:0;" x="5.127" y="4.64"></rect>
            <g id="create-24px" transform="matrix(0.901654, 0, 0, 0.901654, 1.132277, 1.201984)">
                <g id="Group_13292" transform="matrix(0.707107, -0.707107, 0.707107, 0.707107, -1085.204468, 738.142883)">
                    <path id="Path_2042" d="M0,0H14.586V4H0L-2,2Z" transform="translate(1280 261)" class="svg-on-primary-color"></path>
                    <path id="Rectangle_9857" d="M0,0H2A2,2,0,0,1,4,2V2A2,2,0,0,1,2,4H0A0,0,0,0,1,0,4V0A0,0,0,0,1,0,0Z" transform="translate(1296.586 261)" class="svg-on-primary-color"></path>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "editAnswerIcon",
    props: {
        width: {
            type: Number,
            default: 30
        },

        height: {
            type: Number,
            default: 30
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/editAnswerIcon.vue